import React from 'react';
import clsx from 'clsx';

export const TaxesAndFeesIncludedLabel: React.FC<{
  show: boolean;
  currentViewIsTab: boolean;
  fromHotelCard?: boolean;
  label?: string;
  deMapClass?: boolean;
}> = ({ show, currentViewIsTab, fromHotelCard, label, deMapClass }) => {
  if (!show) return null;

  if (!currentViewIsTab && !fromHotelCard) {
    return (
      <div
        className={clsx(
          't-font-alt-xs taxes-and-fees-included',
          deMapClass ? 'text-overflow-ellipsis taxes-and-fees-de' : ''
        )}
      >
        {label}
      </div>
    );
  }

  if (currentViewIsTab) {
    return <div className="t-font-alt-xs taxes-and-fees-included">{label}</div>;
  }

  return null;
};
